<template>
  <div class="collapsable" :class="{ opened }" @click="toggle">
    <label>{{ title }}</label>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Collapsable',
    components: {},
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      title: {
        type: String,
        required: true,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        opened: false,
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      toggle() {
        this.opened = !this.opened;
      },
    },
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .collapsable {
    & > label {
      display: block;
      position: relative;
      font-family: inherit;
      user-select: none;
      cursor: pointer;

      &:before {
        display: inline-block;
        position: relative;
        content: '>';
        width: auto;
        height: inherit;
        margin-right: 8px;
        transform-origin: 50% 50%;
        transform: translate(0,1px) rotate(0) scale(1, 1.6);
        transition: transform $default-transition;
      }
    }

    > div {
      display: none;
    }

    &.opened {
      & > label:before {
        transform: translate(-1px,0) rotate(90deg) scale(1, 1.6);
      }
      & > div {
        display: block;
        padding-left: 16px;
      }
    }

  }
</style>
